import { jsx } from "react/jsx-runtime";
import { useClassName } from "@contember/react-utils";
import { EditorNonEditable } from "./EditorNonEditable.js";
const EditorPlaceholder = (props) => /* @__PURE__ */ jsx(EditorNonEditable, { className: useClassName("editorPlaceholder"), inline: true, children: props.children });
EditorPlaceholder.displayName = "EditorPlaceholder";
export {
  EditorPlaceholder
};
//# sourceMappingURL=EditorPlaceholder.js.map
